import { GET_LIST_PLANS, GET_LIST_PLANS_DONE, GET_LIST_PLANS_ERROR, GET_LIST_PLANS_RESET } from './actionTypes';
export const getListPlans = () => ({
    type: GET_LIST_PLANS
});
export const getListPlansDone = (data) => ({
    type: GET_LIST_PLANS_DONE,
    data
});
export const getListPlansError = (data) => ({
    type: GET_LIST_PLANS_ERROR,
    data
});
export const getListPlansReset = () => ({
    type: GET_LIST_PLANS_RESET
});
//# sourceMappingURL=actionCreators.js.map